<template>
  <!-- The next section overlaps this one by 32px (-mt-8), so the bottom padding
       carries that extra 32px to read as even with the top: 80px / 120px. -->
  <section
    class="bg-mint relative z-2 -mt-8 rounded-t-[40px] pt-20 pb-28 md:pt-30 md:pb-38"
  >
    <DefaultGrid class="gap-y-12 md:gap-y-16">
      <div class="col-span-full text-center">
        <h2
          class="type-font-salt-ss02 text-[56px] leading-[0.9] font-medium tracking-[-0.03em] md:text-[80px]"
        >
          How it works
        </h2>
      </div>

      <div class="col-span-full">
        <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          <div
            v-for="(step, idx) in steps"
            :key="step.title"
            class="flex flex-col rounded-[20px] bg-white p-5"
          >
            <div
              class="aspect-[298/160] overflow-hidden rounded-2xl md:aspect-square"
            >
              <picture>
                <source media="(min-width: 768px)" :srcset="step.image" />
                <img
                  :src="step.imageMobile"
                  alt=""
                  class="h-full w-full object-cover"
                />
              </picture>
            </div>
            <p class="type-heading-5 mt-6">
              {{ idx + 1 }}.&nbsp; {{ step.title }}
            </p>
            <p
              class="mt-3 text-[16px]/[1.3em] font-normal"
              v-text="step.body"
            />
          </div>
        </div>
      </div>

      <div class="col-span-full flex justify-center">
        <PledgeLink location="home_how_it_works" class="btn btn-sm btn-yellow">
          <SvgGlyphPencil />
          <span>Join the movement</span>
        </PledgeLink>
      </div>
    </DefaultGrid>
  </section>
</template>

<script setup lang="ts">
const steps = [
  {
    title: 'Join',
    body: "Join the movement and choose how long you'd like to wait before giving your child a smartphone. It takes less than two minutes.",
    image: '/images/how-it-works-bg-1.svg',
    imageMobile: '/images/how-it-works-bg-1-mobile.svg',
  },
  {
    title: 'Connect',
    body: "Meet other families in your child's school year group who are making the same choice. You decide how much you’d like to connect.",
    image: '/images/how-it-works-bg-2.svg',
    imageMobile: '/images/how-it-works-bg-2-mobile.svg',
  },
  {
    title: 'Build momentum',
    body: 'See your school community grow, receive updates and share Wait Mate with other families when you’re ready.',
    image: '/images/how-it-works-bg-3.svg',
    imageMobile: '/images/how-it-works-bg-3-mobile.svg',
  },
  {
    title: 'Wait together',
    body: 'The more families waiting together, the less pressure sits with any one parent or child. Over time, waiting can become the easier, more normal choice.',
    image: '/images/how-it-works-bg-4.svg',
    imageMobile: '/images/how-it-works-bg-4-mobile.svg',
  },
]
</script>
